import React from 'react'

const IconHeartStrokeCenterCard = ({
  className
}: {
  className: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
    >
      <path
        d="M13.8014 25.1257L14.2148 25.3989L14.6283 25.1257C20.5149 21.2361 23.9579 17.5125 25.6503 14.1736C27.3522 10.8161 27.2845 7.8338 26.117 5.55377C23.938 1.29829 17.9962 -0.241906 14.2148 2.94703C10.4335 -0.241906 4.49169 1.29829 2.31267 5.55377C1.14517 7.8338 1.07747 10.8161 2.77938 14.1736C4.47183 17.5125 7.91478 21.2361 13.8014 25.1257Z"
        fill="#C3C0FC"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default IconHeartStrokeCenterCard
